// extracted by mini-css-extract-plugin
export default {"dialogServiceContainer":"MP5WbJ_ASxAoXM9NQxUQ"};